<div
  #dialog
  class="max-size-form inactivity-modal"
  tabindex="-1"
>
  <div class="inactivity-modal__timer" aria-hidden="true">
    <svg
      class="inactivity-modal__svg"
      [attr.viewBox]="'0 0 ' + viewBoxSize + ' ' + viewBoxSize"
    >
      <circle
        class="inactivity-modal__ring-bg"
        [attr.cx]="viewBoxSize / 2"
        [attr.cy]="viewBoxSize / 2"
        [attr.r]="circleRadius + 2"
        [attr.stroke-width]="strokeWidth"
      ></circle>
      <circle
        class="inactivity-modal__ring-bg"
        [attr.cx]="viewBoxSize / 2"
        [attr.cy]="viewBoxSize / 2"
        [attr.r]="circleRadius"
        [attr.stroke-width]="strokeWidth"
      ></circle>
      <circle
        class="inactivity-modal__ring-bg"
        [attr.cx]="viewBoxSize / 2"
        [attr.cy]="viewBoxSize / 2"
        [attr.r]="circleRadius - 2"
        [attr.stroke-width]="strokeWidth"
      ></circle>
      <circle
        class="inactivity-modal__ring-progress"
        [class.inactivity-modal__ring-progress--critical]="isCritical"
        [attr.cx]="viewBoxSize / 2"
        [attr.cy]="viewBoxSize / 2"
        [attr.r]="circleRadius"
        [attr.stroke-width]="strokeWidth"
        [attr.stroke-dasharray]="circumference"
        [attr.stroke-dashoffset]="progressCircleOffset"
      ></circle>
      <circle
        class="inactivity-modal__ring-pointer"
        [class.inactivity-modal__ring-pointer--critical]="isCritical"
        [attr.cx]="pointerCx"
        [attr.cy]="pointerCy"
        [attr.r]="2"
      ></circle>
    </svg>
    <div
      class="inactivity-modal__time"
      [class.inactivity-modal__time--critical]="isCritical"
    >
      {{ minutes }}:{{ seconds }}
    </div>
  </div>

  <h2 id="inactivity-dialog-title" class="modal__title inactivity-modal__title">
    {{ 'Inactivitydialog.warning_title' | translate }}
  </h2>

  <div id="inactivity-dialog-description" class="modal__text inactivity-modal__text">
    <p>{{ 'Inactivitydialog.warning_message' | translate }}</p>
  </div>

  <p
    class="visually-hidden"
    aria-live="polite"
    aria-atomic="true"
    role="status"
  >
    {{ 'Inactivitydialog.warning_aria_time' | translate: { minutes: minutes, seconds: seconds } }}
  </p>

  <div class="modal__group-button inactivity-modal__buttons">
    <button
      #primaryButton
      type="button"
      class="modal__btn btn--primary"
      (click)="onContinue()"
    >
      {{ 'Inactivitydialog.warning_continue' | translate }}
    </button>
    <button
      #secondaryButton
      type="button"
      class="modal__btn btn--secondary"
      (click)="onLogout()"
    >
      {{ 'Inactivitydialog.warning_logout' | translate }}
    </button>
  </div>
</div>
